import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Row, Table } from "reactstrap";

import { useNavigate } from "react-router-dom";
import { BiEditAlt, BiTrash } from "react-icons/bi";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { BiLeftArrowAlt } from "react-icons/bi";
import { GiCheckMark } from "react-icons/gi";
import { ImCross, ImCheckmark } from "react-icons/im";
import useAuth from '../../hooks/useAuth';

const InvestmentView = () => {
  const { auth } = useAuth();

  const [modal, openModal] = useState(false);
  const toggle = () => openModal(!modal);
  const [investment, setInvestment] = useState([]);
  const navigate = useNavigate();

  const handleDelete = async (event, id) => {
    event.preventDefault();
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/investment-services/delete/${id}`,
        {
          headers: {
            Authorization:
              "Bearer " + auth.accessToken,
          },
        }
      );
      const res1 = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/investment-services/find-all`
      );
      setInvestment(res1.data);
      toast.success(res.data.message, {
        className: "success-toast",
        autoClose: 3000,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      error.response.data.message
        ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          })
        : toast.error(error.response.data.error, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          });
    }
  };

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getinvestment = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/investment-services/find-all`,
          {
            cancelToken: source.token,
          }
        );
        setInvestment(res.data);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }
    };

    getinvestment();
    return () => {
      source.cancel();
    };
  }, []);

  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Investment Service List</h5>
      </Row>
      <Row>
        <Table responsive hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Subtitle</th>
              <th>Description</th>
              <th>Monthly Fee</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {investment.map((investment) => (
              <tr key={investment.id}>
                <td>{investment.id}</td>
                <td style={{ wordBreak: "break-all" }}>{investment.invServiceTitle.join(",")}</td>
                <td style={{ wordBreak: "break-all" }}>{investment.invServiceSubTitle.join(",")}</td>
                <td style={{ wordBreak: "break-all" }} dangerouslySetInnerHTML={{ __html: investment.investServiceDesc.substring(0, 150)}}></td>
                <td>{investment.fees}</td>
                <td>
                  <BiEditAlt
                    className="edit_icon icon_hover"
                    onClick={() => navigate(`/investment/edit/${investment.id}`)}
                    size={30}
                  />
                  {/* <BiTrash
                    className="delete_icon icon_hover"
                    onClick={(event) => handleDelete(event, investment.id)}
                    size={20}
                  /> */}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Row>
      {/* {investment && (
        <Row sm="12" className="mt-4 text-center">
          <Link to={"/investment/add"} className="go_back">
            <BiLeftArrowAlt size={30} /> Go to Add Investment Service
          </Link>
        </Row>
      )} */}
    </div>
  );
};

export default InvestmentView;
